export interface BarzhaTask {
  ad_subscription_campaign_id: number;
  title: string;
  description: string;
  image_href: string;
  button_text: string;
  provider: 'BARZHA';
  status?: string;
  rewards: {
    stars: number;
  };
}

export interface BarzhaResponse {
  status: string;
  error?: string;
  tasks: BarzhaTask[];
}

export interface BarzhaStatusTask {
  task_id: string;
  status: string;
  type: string;
  visibility: boolean;
}

export enum BarzhaStatus {
  Subscribed = 'subscribed',
  NotStarted = 'not_started',
  Active = 'active',
  Claim = 'claim',
  Waiting = 'waiting',
  Done = 'done',
}
